"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withRouteIndicator = void 0;
const router_1 = __importDefault(require("next/router"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_1 = __importStar(require("react"));
const Indicator = styled_components_1.default.div `
  position: fixed;
  left: 0;
  top: 0;
  right: 100%;
  z-index: 1000;
  height: ${(props) => { var _a; return (_a = props === null || props === void 0 ? void 0 : props.height) !== null && _a !== void 0 ? _a : 4; }}px;
  box-shadow: 0 1px 8px hsla(0, 0%, 0%, 0.1);
  opacity: 0;
  transition-property: right, opacity;
  transition-duration: 0s;
  pointer-events: none;
  background-color: ${(props) => { var _a; return (_a = props === null || props === void 0 ? void 0 : props.color) !== null && _a !== void 0 ? _a : "#f85656"; }};

  &.loading {
    right: 5%;
    opacity: 1;
    transition-timing-function: cubic-bezier(0.075, 0.82, 0.165, 1);
    transition-duration: 8s, 0s;
  }

  &.done {
    right: 0;
    transition-duration: 250ms;
    transition-delay: 0s, 250ms;
  }
`;
const withRouteIndicator = (options = { color: "#f85656", height: 4 }) => (PageComponent) => {
    const { color, height } = options;
    const WithIndicator = (props) => {
        const [loading, setLoading] = (0, react_1.useState)(false);
        const [timeoutId, setTimeoutId] = (0, react_1.useState)(null);
        const loadingStyle = loading ? "loading" : "done";
        const onPageLoad = () => __awaiter(void 0, void 0, void 0, function* () {
            setLoading(true);
        });
        const onPageDone = () => __awaiter(void 0, void 0, void 0, function* () {
            setLoading(false);
            setTimeoutId(setTimeout(() => {
                setTimeoutId(null);
                setLoading(false);
            }, 2500));
        });
        (0, react_1.useEffect)(() => () => {
            if (timeoutId)
                clearTimeout(timeoutId);
        }, [timeoutId]);
        (0, react_1.useEffect)(() => {
            router_1.default.events.on("routeChangeStart", onPageLoad);
            router_1.default.events.on("routeChangeComplete", onPageDone);
            router_1.default.events.on("routeChangeError", onPageDone);
            return () => {
                router_1.default.events.off("routeChangeStart", onPageLoad);
                router_1.default.events.off("routeChangeComplete", onPageDone);
                router_1.default.events.off("routeChangeError", onPageDone);
            };
        });
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Indicator, { id: "route-loading-indicator", className: loadingStyle, color: color, height: height }),
            react_1.default.createElement(PageComponent, Object.assign({}, props))));
    };
    if (process.env.NODE_ENV !== "production") {
        const displayName = PageComponent.displayName || PageComponent.name || "Component";
        WithIndicator.displayName = `withRouteIndicator(${displayName})`;
    }
    return WithIndicator;
};
exports.withRouteIndicator = withRouteIndicator;
exports.default = exports.withRouteIndicator;
//# sourceMappingURL=index.js.map